import { connect } from 'react-redux';

import AlertActions from 'reducers/alert';

const mapStateToProps = ({ alert }) => ({
  ...alert,
});

const mapDispatchToProps = {
  ...AlertActions,
};

export default connect(mapStateToProps, mapDispatchToProps);
